import { mapCursosInscritosForPerfil } from "../../../utils/perfilCursosInscritosList";
import { newGestorCursoRow } from "./cursoSelectionRow";

export { newGestorCursoRow };

/**
 * @param {unknown} cursosInscritos
 * @returns {Array<{ id: string; cursoId: string }>}
 */
export function cursosInscritosToGestorRows(cursosInscritos) {
  const mapped = mapCursosInscritosForPerfil(cursosInscritos);
  if (mapped.length === 0) {
    return [newGestorCursoRow()];
  }
  return mapped.map((curso) => {
    const row = newGestorCursoRow();
    return { id: row.id, cursoId: curso.id };
  });
}

export { uniqueCourseIdsFromRows as uniqueCourseIdsFromGestorRows } from "./registrousuarioCursosPayload";

/**
 * @param {Array<{ cursoId: string }>} rows
 * @param {Array<{ _id: string }>} cursosDisponibles
 * @returns {boolean}
 */
export function allCatalogCoursesSelected(rows, cursosDisponibles) {
  if (cursosDisponibles.length === 0) {
    return false;
  }

  const selectedIds = new Set(
    rows
      .map((row) => row.cursoId)
      .filter((courseId) => typeof courseId === "string" && courseId.trim() !== "")
      .map((courseId) => courseId.trim()),
  );

  return cursosDisponibles.every((curso) => selectedIds.has(String(curso._id)));
}

/**
 * @param {string[]} left
 * @param {string[]} right
 * @returns {boolean}
 */
export function sameCourseIdSelection(left, right) {
  const a = [...new Set(left.map(String))].sort();
  const b = [...new Set(right.map(String))].sort();
  if (a.length !== b.length) return false;
  return a.every((value, index) => value === b[index]);
}
